// Must precede prismjs: it disables Prism's automatic pass over the document.
import "./prismManual"
import Prism from "prismjs"
import "@/assets/prismNovaTheme.css"

export type CodeLanguage = "markup" | "css" | "javascript"

/** Prism escapes the source while tokenising, so the result is safe to v-html. */
export function highlightCode(code: string, language: CodeLanguage): string {
  const grammar = Prism.languages[language]
  if (!grammar) return escapeHtml(code)
  return Prism.highlight(code, grammar, language)
}

function escapeHtml(value: string): string {
  return value
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
}
